import { ErrorTypes } from '@wix/form-validator';
import { DerivedErrorTypes } from '../../field-error/error-types';
export const getTextInputFieldError = (validation, error) => {
  var _validation$string, _validation$string2;
  const isMinMaxLengthError = (error == null ? void 0 : error.errorType) === ErrorTypes.MIN_LENGTH_ERROR || (error == null ? void 0 : error.errorType) === ErrorTypes.MAX_LENGTH_ERROR;
  if (!error || !isMinMaxLengthError) {
    return error;
  }
  const minLength = validation == null || (_validation$string = validation.string) == null ? void 0 : _validation$string.minLength;
  const maxLength = validation == null || (_validation$string2 = validation.string) == null ? void 0 : _validation$string2.maxLength;
  const isMinMaxValues = minLength && maxLength;
  if (isMinMaxValues && minLength === maxLength) {
    return {
      ...error,
      errorType: DerivedErrorTypes.EXACT_CHARACTER_LENGTH_ERROR,
      errorMessage: `must have exactly ${minLength} characters`
    };
  }
  if (isMinMaxValues && minLength !== maxLength) {
    return {
      ...error,
      errorType: DerivedErrorTypes.CHARACTER_LENGTH_RANGE_ERROR,
      errorMessage: `must have between ${minLength} and ${maxLength} characters`,
      params: {
        minLimit: minLength,
        maxLimit: maxLength
      }
    };
  }
  return error;
};
//# sourceMappingURL=text-input-field-utils.js.map